/**
 * Print stylesheet constants for waste checksheet printing.
 * Separated from component code so styles are easy to maintain and extend.
 */

const basePrintStyles = `
  * { box-sizing: border-box; }
  body {
    margin: 0;
    padding: 16px 18px;
    font-family: Arial, Helvetica, sans-serif;
    color: #1f2937;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
  }
  .category-section {
    margin-bottom: 20px;
    break-inside: avoid;
    page-break-inside: avoid;
  }
  .category-title {
    font-size: 13px;
    font-weight: 700;
    color: #334155;
    margin-bottom: 4px;
    padding: 5px 8px;
    background: #f1f5f9;
    border-bottom: 2px solid #cbd5e1;
  }
  th {
    text-align: left;
    border-bottom: 2px solid #d1d5db;
    padding: 5px 6px 6px;
    font-size: 9px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    vertical-align: bottom;
    color: #374151;
  }
  td {
    border-top: 1px solid #e5e7eb;
    padding: 5px 5px;
    font-size: 10px;
    line-height: 1.3;
    vertical-align: top;
    white-space: normal;
  }
  tr {
    break-inside: avoid;
    page-break-inside: avoid;
  }
  .item-number {
    font-weight: 700;
    color: #334155;
    font-size: 10px;
  }
  .item-description {
    word-break: break-word;
    overflow-wrap: anywhere;
    font-size: 10px;
    line-height: 1.3;
  }
  .uom-info {
    white-space: pre-line;
    font-size: 9px;
    line-height: 1.4;
  }
  @page {
    size: A4 landscape;
    margin: 8mm;
  }
`;

/**
 * Legacy print styles (non-UOM mode).
 * Simple write areas with ruled lines for recording quantities.
 */
export const legacyPrintStyles = `
  ${basePrintStyles}
  .input-box {
    height: 36px;
    border: 1.5px solid #94a3b8;
    border-radius: 4px;
    background: #fff;
  }
`;

/**
 * UOM-aware print styles.
 * Larger write areas with UOM tick boxes so users can mark which
 * unit of measure they're recording against. Designed for tally charts.
 */
export const uomPrintStyles = `
  ${basePrintStyles}
  .reason-cell {
    padding: 4px !important;
  }
  .input-box {
    height: 36px;
    border: 1.5px solid #94a3b8;
    border-radius: 4px;
    background: #fff;
    margin-bottom: 4px;
  }
  .uom-ticks {
    display: flex;
    flex-wrap: wrap;
    gap: 4px 8px;
    padding-top: 4px;
    border-top: 1px dashed #cbd5e1;
  }
  .uom-tick {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    font-size: 9px;
    color: #374151;
    white-space: nowrap;
  }
  .uom-tick .tick-box {
    width: 13px;
    height: 13px;
    border: 1.5px solid #6b7280;
    border-radius: 2px;
    display: inline-block;
    flex-shrink: 0;
  }
`;
